import app, { Component } from 'apprun';
import { showSaveStatusMessage } from '../utils';

import { users } from '../api';
import PasswordInput from '../password-input';

export default class CommonPropertyComponent extends Component {
  state = {};

  // prettier-ignore
  view = (state) => {
    if (!state.caller) {return;}
    return (
      <form class="form-horizontal" style={{ width: '450px' }}>
        <div class="row">
          <div class="col-sm-12">New Password</div>
          <div class="col-sm-12">
            <PasswordInput id="inpText" size={62} class="form-control"/>
          </div>
          <div class="col-sm-12">Confirm Password</div>
          <div class="col-sm-12">
            <PasswordInput id="confirmText" size={62} class="form-control"/>
          </div>
        </div>
        <div id="inpTextErrMsg" class="text-danger"></div>
        <div class="edit-buttons">
          <a type="button" class="btn btn-primary btn-xs" onclick={() => this.run('save')}>
            save
          </a>
          <a type="button" class="btn btn-default btn-xs" onclick={() => state.caller.run(state.cancel, state.panelId)}>
            cancel
          </a>
        </div>
      </form>
    );
  };

  update = {
    save: async (state) => {
      const inpText = ((document.getElementById('inpText') || {}) as HTMLInputElement).value;
      const confirmText = ((document.getElementById('confirmText') || {}) as HTMLInputElement).value;
      const errDiv = document.getElementById('inpTextErrMsg') as HTMLDivElement;

      if (!inpText) {
        errDiv.innerHTML = 'Please enter a value for new password';
      } else if (inpText !== confirmText) {
        errDiv.innerHTML = 'value in confirmation box does not match';
      } else {
        errDiv.innerHTML = '';
        try{
          const result = await users.setPassword(state.personId, inpText.trim());
          showSaveStatusMessage(result===1);
          if (result === 1) {
            state.caller.run(state.cancel, state.panelId);
          } else {
            errDiv.innerHTML = result;
          }
        }catch{showSaveStatusMessage();}
      }
    },
  };

  mounted = ({ state }) => state;
}
